import React from 'react';
import PropTypes from 'prop-types';
import StaffSearch from 'components/Physician/StaffSearch';
import Icon from 'components/Utils/NewIcon';

const StaffSearchModal = ({
  title,
  backButton,
  ignoreAdmins,
  ignorePhysicians,
  hideInactive,
  onSelect,
}) => {
  return (
    <div className="modal physician-search-modal">
      <div className="title">
        {backButton ? (
          <div onClick={backButton} className="back-button">
            <Icon src="arrow-left" />
          </div>
        ) : null}
        {title || 'Select Practitioner'}
      </div>
      <div className="content">
        <StaffSearch
          onSelect={onSelect}
          ignoreAdmins={ignoreAdmins}
          ignorePhysicians={ignorePhysicians}
          hideInactive={hideInactive}
        />
      </div>
    </div>
  );
};

StaffSearchModal.propTypes = {
  backButton: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  title: PropTypes.string,
  ignoreAdmins: PropTypes.bool,
  ignorePhysicians: PropTypes.bool,
};

export default StaffSearchModal;
